// ======================================================================
// File Name       : UserHistoryContentAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import _ from 'lodash';
import * as actionTypes from '../constants/actionTypes/user';
import { REPORT_STATUS } from '../constants/ArchivementConstant';
import { commonCallApi } from '../utils/ApiUtils';
import { SELECT_TARGET_DATA, RETURN_MAX_NUM } from '../constants/index';
import { CONTENT_TYPE } from '../constants/ContentHistoryConstant';
import * as userHistoryContentActionCreators from './actionCreators/userHistoryContent';
import * as userHistoryContentRequests from './httpRequests/userHistoryContent';

export function getContentList(searchInfo, selectTargetData, isGetContentName) {
  return (dispatch) => {
    // incase get content Name only or search by content name or content secern id, call API get content list
    if (isGetContentName || searchInfo.contentName || searchInfo.contentSecernId) {
      // call content get list
      const param = {
        selectTargetData,
        searchInfo: {
          contentSecernId: searchInfo.contentSecernId || null,
          contentName: searchInfo.contentName || null,
          contentList: isGetContentName ? searchInfo.contentList : null,
          excludeQuestion: true,
        },
      };
      return userHistoryContentRequests.getContentList(param)
        .then((camelizeJson) => {
          dispatch(userHistoryContentActionCreators.receiveContentList(camelizeJson, searchInfo));
          // incase get content name only, don't call API get itemt list
          if (!isGetContentName) {
            const { contentList } = camelizeJson;
            const contentListTemp = [];
            contentList && contentList.length &&
            contentList.forEach((contentInfo) => {
              const { contentSecernId, contentType } = contentInfo;
              // STEP 12.2.0 START
              if (contentType !== 2) {
                contentListTemp.push({ contentSecernId, contentType });
              }
              // STEP 12.2.0 END
            });
            if (contentListTemp && contentListTemp.length) {
              searchInfo.contentList = contentListTemp;
              dispatch(getItemList(searchInfo, selectTargetData));
            } else {
              const result = { recordNum: 0, itemList: [] };
              dispatch(userHistoryContentActionCreators.receiveItemList(result, searchInfo));
            }
          }
        });
    }
    // call item get list
    return dispatch(getItemList(searchInfo, selectTargetData));
  };
}

export function getItemList(searchInfo, selectTargetData) {
  return (dispatch) => {
    const param = {
      selectTargetData,
      searchInfo: {
        contentList: searchInfo.contentList && searchInfo.contentList.length ? searchInfo.contentList : null,
        contentType: isNaN(searchInfo.contentType) ? null : parseInt(searchInfo.contentType, 10),
        dataAffiliationType: isNaN(searchInfo.dataAffiliationType) ? null : parseInt(searchInfo.dataAffiliationType, 10),
        itemSortType: isNaN(searchInfo.itemSortType) ? null : parseInt(searchInfo.itemSortType, 10),
        ascendingDescendingSort: isNaN(searchInfo.ascendingDescendingSort) ? null : parseInt(searchInfo.ascendingDescendingSort, 10),
        startPosition: searchInfo.startPosition || 0,
        returnMaxNum: searchInfo.returnMaxNum || RETURN_MAX_NUM,
      },
    };
    return userHistoryContentRequests.getItemList(param)
      .then((camelizeJson) => {
        dispatch(userHistoryContentActionCreators.receiveItemList(camelizeJson, searchInfo));
        const { itemList } = camelizeJson;
        const itemSecernIds = [];
        const contentSecernIds = [];
        itemList.forEach((itemInfo, index) => {
          const { itemSecernId } = itemInfo;
          itemSecernIds.push(itemSecernId);
          if (itemInfo.contentInfo && itemInfo.contentInfo.contentSecernId) {
            contentSecernIds.push(itemInfo.contentInfo.contentSecernId);
          }
        });
        if (itemSecernIds && itemSecernIds.length) {
          dispatch(getEachItemStatusCount(itemSecernIds, searchInfo, selectTargetData));
        }
        if (!searchInfo.contentName && !searchInfo.contentSecernId) {
          if (contentSecernIds && contentSecernIds.length > 0) {
            searchInfo.contentList = contentSecernIds;
            dispatch(getContentList(searchInfo, selectTargetData, true));
          } else {
            const result = { recordNum: 0, contentList: [] };
            dispatch(userHistoryContentActionCreators.receiveContentList(result, searchInfo));
          }
        }
      });
  };
}

function getEachItemStatusCount(itemSecernIds, searchInfo, selectTargetData) {
  return (dispatch) => {
    const param = {
      selectTargetData,
      searchInfo: {
        itemList: itemSecernIds,
        learningEndTimeFrom: searchInfo.learningEndTimeFrom || null,
        learningEndTimeTo: searchInfo.learningEndTimeTo || null,
      },
    };
    userHistoryContentRequests.getEachItemStatusCount(param).then((reponse) => {
      dispatch(userHistoryContentActionCreators.receiveEachItemStatusCount(reponse));
    });
  };
}

export function getHistoryListByItemList(searchInfo, selectTargetData) {
  const param = {
    searchInfo,
    selectTargetData,
  };
  return dispatch => userHistoryContentRequests
    .getExecutionNumber(param)
    .then((result) => {
      if (selectTargetData === SELECT_TARGET_DATA.DATA) {
        dispatch(userHistoryContentActionCreators.receiveExecutionNumber(result));
        if (result && result.learningHistoryList && result.learningHistoryList.length) {
          const userSecernIdList = [];
          result.learningHistoryList.forEach((item) => {
            userSecernIdList.push(item.userSecernId);
          });
          if (userSecernIdList && userSecernIdList.length) {
            dispatch(getUserList(userSecernIdList));
          }
        }
      }
    });
}

function getUserList(userSecernIds) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        userSecernIdList: userSecernIds,
      },
    };

    userHistoryContentRequests
      .getUserList(
      param,
    )
      .then((camelizeJson) => {
        dispatch(userHistoryContentActionCreators.receiveUserList(camelizeJson));

        const { userList } = camelizeJson;

        const userSecernIdList = [];
        userList.forEach((userInfo) => {
          const { userSecernId } = userInfo;
          userSecernIdList.push(userSecernId);
        });
        if (userSecernIdList && userSecernIdList.length) {
          dispatch(getGroupRelationList(userSecernIdList));
        }
      });
  };
}

export function getGroupList(userSecernIdList) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
    };
    userHistoryContentRequests
      .getGroupList(
      param,
    )
      .then((camelizeJson) => {
        dispatch(userHistoryContentActionCreators.receiveGroupList(camelizeJson));
      });
  };
}

export function getGroupRelationList(userSecernIdList) {
  return (dispatch) => {
    const param = {
      selectTargetData: SELECT_TARGET_DATA.DATA,
      searchInfo: {
        userList: userSecernIdList,
      },
    };

    userHistoryContentRequests
      .getGroupRelationList(param)
      .then((camelizeJson) => {
        dispatch(userHistoryContentActionCreators.receiveGroupRelationList(camelizeJson));
        if (camelizeJson && camelizeJson.groupRelationList && camelizeJson.groupRelationList.length) {
          const groupSecernIdList = [];
          camelizeJson.groupRelationList.forEach((group) => {
            const { groupSecernId } = group;
            groupSecernIdList.push(groupSecernId);
          });
          if (groupSecernIdList && groupSecernIdList.length) {
            dispatch(getGroupList(groupSecernIdList));
          }
        }
      });
  };
}

// #7386 START
export function getEachDrillEnforceStatusSummary(params) {
  return (dispatch) => userHistoryContentRequests.getEachDrillEnforceStatusSummary(params).then((result) => {
    dispatch(userHistoryContentActionCreators.receiveEachDrillEnforceStatusSummary(result));
  });
}

export function getEachQuestionAnswerContentSummary(params) {
  return (dispatch) => userHistoryContentRequests.getEachQuestionAnswerContentSummary(params).then((result) => {
    dispatch(userHistoryContentActionCreators.receiveEachQuestionAnswerContentSummary(result));
  });
}

export function getHistoryListByItemSecernId(searchInfo, selectTargetData) {
  const param = {
    searchInfo,
    selectTargetData,
  };
  return (dispatch) => userHistoryContentRequests
    .getExecutionNumber(param)
    .then((result) => {
      if (selectTargetData === SELECT_TARGET_DATA.DATA) {
        dispatch(userHistoryContentActionCreators.receiveExecutionNumber(result));
      }
    });
}
// #7386 END

// #7464 START
export function resetData() {
  return (dispatch) => {
    dispatch(userHistoryContentActionCreators.resetData());
  };
}
// #7464 END
